import { render, staticRenderFns } from "./CouponToggle.vue?vue&type=template&id=155343a8"
import script from "./CouponToggle.vue?vue&type=script&lang=js"
export * from "./CouponToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports